import { DEFAULTS } from "./defaults";
import { TABLE_TYPE } from "./types";
import { nodeViewRenderers } from "./viewer/nodeViewRenderers-loadable";
const pluginTable = (config) => {
  return {
    config: { ...DEFAULTS.config, ...config },
    type: TABLE_TYPE,
    nodeViewRenderers
  };
};
export {
  pluginTable
};
//# sourceMappingURL=viewer-loadable.js.map
